// Shared class constants for the mobile navigation sidebar. Values mirror the
// Figma mobile menu (node 14763-95035) snapped to the 3px spacing scale.

export const ITEM_LABEL_CLASS = 'font-inter text-nav font-semibold leading-normal';

export const FOCUS_RING_CLASS =
  'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-off-black/30';

export const ITEM_ROW_CLASS = `flex w-full items-center gap-4 p-4 rounded-input text-text-primary touch-manipulation ${ITEM_LABEL_CLASS} ${FOCUS_RING_CLASS}`;

export const ACTIVE_ROW_CLASS = 'bg-dinnerplate-white-light';

export const HOVER_ROW_CLASS = 'hover:bg-dinnerplate-white-light';

export const SECTION_LABEL_CLASS = `text-grey ${ITEM_LABEL_CLASS}`;

export const NAV_ICON_CLASS = 'w-6 h-6 flex-shrink-0';

// Children of an expandable, indented so the vertical connector sits on the
// parent icon's centerline (12px row padding + half the 18px icon = 21px).
export const CHILD_LIST_CLASS = 'ml-7 border-l border-grey-light py-2 pl-3 flex flex-col gap-4';

export const CHILD_ROW_CLASS = `flex w-full items-center px-4 py-1 rounded-xs text-text-primary touch-manipulation ${ITEM_LABEL_CLASS} ${FOCUS_RING_CLASS} ${HOVER_ROW_CLASS}`;

export const DISABLED_ITEM_CLASS = 'opacity-40 cursor-not-allowed pointer-events-none';

// Mobile nav drawer enter/exit — scoped here so the shared Sheet primitive stays default.
export const MOBILE_DRAWER_OVERLAY_ANIMATION =
  'data-[state=closed]:duration-200 data-[state=open]:duration-250 data-[state=closed]:ease-out data-[state=open]:ease-out motion-reduce:data-[state=open]:animate-none motion-reduce:data-[state=closed]:animate-none';

export const MOBILE_DRAWER_CONTENT_ANIMATION =
  'overscroll-contain origin-left data-[state=closed]:duration-200 data-[state=open]:duration-250 data-[state=closed]:ease-out data-[state=open]:ease-out motion-reduce:data-[state=open]:animate-none motion-reduce:data-[state=closed]:animate-none';